// extracted by mini-css-extract-plugin
export default {"listsContainer":"BlockTextList_listsContainer__mRec9","textItem":"BlockTextList_textItem__HHF6R"};